/**
 * Explicit slug → bundled SVG asset map (NOT `import.meta.glob`), so a slug that
 * references a missing asset fails at BUILD time and tree-shaking stays
 * predictable. Assets are imported as ESM URLs; they work identically in
 * standalone and embedded (Core Shell) builds.
 *
 * Providers deliberately WITHOUT a logo (Spreadsheet, Internal Billing API)
 * are absent here and render initials via `IntegrationProviderLogo`.
 */
import amazonS3 from '../assets/logos/amazon-s3.svg';
import datadog from '../assets/logos/datadog.svg';
import github from '../assets/logos/github.svg';
import googleDrive from '../assets/logos/google-drive.svg';
import jira from '../assets/logos/jira.svg';
import linear from '../assets/logos/linear.svg';
import notion from '../assets/logos/notion.svg';
import salesforce from '../assets/logos/salesforce.svg';
import slack from '../assets/logos/slack.svg';
import snowflake from '../assets/logos/snowflake.svg';
import zendesk from '../assets/logos/zendesk.svg';

export const INTEGRATION_PROVIDER_LOGOS = {
  'amazon-s3': amazonS3,
  datadog,
  github,
  'google-drive': googleDrive,
  jira,
  linear,
  notion,
  salesforce,
  slack,
  snowflake,
  zendesk,
};

/** Returns the bundled logo URL for a slug, or '' when none exists (→ initials). */
export const getIntegrationProviderLogo = (slug) => INTEGRATION_PROVIDER_LOGOS[slug] ?? '';
